var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import classNames from 'classnames';
import { ArrayMode } from './array';
import { TreeNodeCascader } from '@comall-backend-builder/components-basis';
import { services } from '@comall-backend-builder/core';
var TreeNodeIdsCascader = services.TreeNodeArrayToTreeNodeIdArrayHOC(TreeNodeCascader);

var ArrayTreeNodeIdsCascaderMode = function (_super) {
  __extends(ArrayTreeNodeIdsCascaderMode, _super);

  function ArrayTreeNodeIdsCascaderMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 获取展示组件
   */


  ArrayTreeNodeIdsCascaderMode.prototype.getDisplayComponent = function (array, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style,
        options = displayInfo.options,
        _a = displayInfo.separator,
        separator = _a === void 0 ? '/' : _a;
    var namesArr = services.convertTreeNodeIdArrayToTreeNodeArray(array, options).map(function (item) {
      return item.name;
    }).join(separator);

    if (array && array.length) {
      return React.createElement("span", {
        className: classNames('type-array', className),
        style: style
      }, namesArr);
    } else {
      return _super.prototype.getNotAvailableDisplayComponent.call(this, displayInfo);
    }
  };
  /**
   * 获取输入组件
   */


  ArrayTreeNodeIdsCascaderMode.prototype.getControlComponent = function (controlInfo) {
    return React.createElement(TreeNodeIdsCascader, __assign({}, controlInfo));
  };

  return ArrayTreeNodeIdsCascaderMode;
}(ArrayMode);

export { ArrayTreeNodeIdsCascaderMode };